module.exports = __webpack_public_path__ + "static/media/chi-siamo.9cbc46e7.svg";